module.exports = __webpack_public_path__ + "static/arrow-a95ffbd8ec7437a9aaa8e0a019742647.png";